export default __webpack_public_path__ + "static/1551-6c98c0e1ca6300eb5941cb1fd1624e8b.gif";